var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何将印章授权给成员使用")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“企业控制台”进入企业管理界面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img13.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "2.点击“印章及授权”，进入企业印章页面，点击印章下的印章授权按钮；"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img14.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v("3.点击授权给成员按钮，弹窗中选择要授予的成员，点击确认。")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img15.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07ade12a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ade12a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/5_signToMenber.vue
// module id = etuk
// module chunks = 54 238